import React, { useEffect, useState } from "react";
import { Doughnut, Chart } from "react-chartjs-2";
import FETCH from "../../../../utils/fetch";
import Loader from "../../../styled-components/loader/loader";
import { chartColors } from "./color";
import { ChartColors } from "../../../ChartColors";
import "../style/debtPayOff.css";
import NewLoader from "../../../styled-components/loader/NewLoader";
export const CategoryChart = (props) => {
  const [loading, setLoading] = useState(false);
  const [monthlyPayment, setMonthlyPayment] = useState([]);
  const [moduleTotal, setModuleTotal] = useState([]);

  console.log("module", moduleTotal);
  console.log("monthlyPayment", monthlyPayment);
  const uniqueModules = [
    ...new Set(props.data && props.data.map((data) => data.module)),
  ];

  const valueTotal =
    props.data &&
    props.data.reduce((sum, item) => {
      const amount = parseFloat(item["Initial Loan Amount"]);
      return isNaN(amount) ? sum : sum + amount;
    }, 0);

  useEffect(() => {
    const series = uniqueModules.map(
      (module) =>
        props.data &&
        props.data.reduce((sum, data) => {
          if (data.module === module) {
            const amount = parseFloat(data["Initial Loan Amount"]);
            return isNaN(amount) ? sum : sum + amount;
          } else {
            return sum;
          }
        }, 0)
    );
    setMonthlyPayment(series);
    console.log("values from useEffect==>", series, uniqueModules);
  }, [props.data]);

  const dataDonught = {
    labels: uniqueModules && uniqueModules,
    datasets: [
      {
        label: "# of Votes",
        data: monthlyPayment && monthlyPayment,
        backgroundColor: chartColors,
        borderColor: chartColors,
        // backgroundColor: uniqueModules && uniqueModules.map((_, index) =>
        //   ChartColors[index % ChartColors.length] // Cycle through ChartColors
        // ),
        // borderColor: uniqueModules && uniqueModules.map((_, index) =>
        //   ChartColors[index % ChartColors.length] // Same for borderColor
        // ),
        borderWidth: 1,
      },
    ],
    text: `${
      valueTotal &&
      `${
        "$" +
        valueTotal
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }`
    }`,
  };
  var originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
  Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
    draw: function () {
      originalDoughnutDraw.apply(this, arguments);

      var chart = this.chart.chart;
      var ctx = chart.ctx;
      var width = chart.width;
      var height = chart.height;

      var text = chart.config.data.text;
      // console.log(chart, ctx)

      var sidePadding = 20;
      var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);

      ctx.font = "30px " + "Arial";

      //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
      var stringWidth = ctx.measureText(text).width;
      var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

      // Find out how much the font can grow in width.
      var widthRatio = elementWidth / stringWidth;
      var newFontSize = Math.floor(30 * widthRatio);
      var elementHeight = chart.innerRadius * 2;

      // Pick a new font size so it will not be larger than the height of label.
      var fontSizeToUse = Math.min(newFontSize, elementHeight);

      var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
      var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

      var fontSize = (height / 114).toFixed(2);
      ctx.font = fontSize + "em Verdana";
      ctx.textBaseline = "middle";

      ctx.textAlign = "center";
      ctx.font = fontSizeToUse + "px " + "Arial";

      var textX = Math.round((width - ctx.measureText(text).width) / 2);
      var textY = height / 2;

      ctx.fillText(text, centerX, centerY);
    },
  });

  return (
    <div style={{ position: "relative" }}>
      <div className="cardHeadingDebt">Balance by Category</div>
      <div style={{ marginTop: "1rem" }}>
        {monthlyPayment && module && (
          <Doughnut
            data={dataDonught}
            options={{
              cutoutPercentage: 70,
              legend: {
                display: true,
                position: "right",
              },
            }}
          />
        )}
      </div>
      <NewLoader isLoading={props.loading} />
      {/*<Loader isLoading={loading} /> */}
    </div>
  );
};
